interface ILEAVE_ENCASHMENT_FORMULA {
  employType: string;
  encashDuring: string;
  yearsOfService: number;
  basic: number;
  unusedLeaves: number;
  leavesPerYear: number;
}

export const LEAVE_ENCASHMENT_FORMULA = ({
  employType,
  encashDuring,
  yearsOfService,
  basic,
  unusedLeaves,
  leavesPerYear,
}: ILEAVE_ENCASHMENT_FORMULA) => {
  const employ = String(employType);
  const encashed = String(encashDuring);
  const years = Number(yearsOfService);
  const salPlusDA = Number(basic);
  const leavesAvailable = Number(unusedLeaves);
  const yearlyLeaves = Number(leavesPerYear);

  if (
    years < 1 ||
    years > 50 ||
    salPlusDA < 1 ||
    salPlusDA > 1e10 ||
    leavesAvailable < 0 ||
    leavesAvailable > 1e4 ||
    yearlyLeaves < 0 ||
    yearlyLeaves > 1e4
  ) {
    const resEmpty = 0;
    return {
      leaveEncashment: resEmpty,
      exemption: resEmpty,
      taxableLeave: resEmpty,
    };
  }

  const totalLeaves = yearlyLeaves * years;
  const avgSal = salPlusDA / 30;
  const eligible = years * 30;
  const unused = Math.max(0, eligible - (totalLeaves - leavesAvailable));
  const leaveEncash = avgSal * leavesAvailable;
  const itProvision = avgSal * unused;
  let exempt = 0;
  if (encashed == 'during') exempt = 0;
  else {
    if (employ == 'NonGov')
      exempt = Math.min(25e5, itProvision, leaveEncash, salPlusDA);
    else if (employ == 'Gov') exempt = leaveEncash;
  }
  const res = leaveEncash - exempt > 0 ? Math.round(leaveEncash - exempt) : 0;
  return {
    leaveEncashment: Math.round(leaveEncash),
    exemption: Math.round(exempt),
    taxableLeave: Math.round(res),
  };
};
